/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: file-system-search-view-component.ts
 *
 * Created by kyang on 2020-09-11.
 */

function FileSystemSearchViewController(
    this: JS5Object,
    $location: JS5Object,
    FileSystemService: JS5Object,
    NavbarUtilService: JS5Object,
    PaginationService: JS5Object,
    PermissionsService: JS5Object,
    SearchFilterService: JS5Object,
    uiGridConstants: JS5Object,
) {

    //======//
    // Grid //
    //======//

    const columnDefs = [
        {
            field: 'name',
            displayName: 'Name',
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }, {
            field: 'typeName',
            displayName: 'Type',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }, {
            field: 'pathPrefix',
            displayName: 'Path Prefix',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];

    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: false,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: columnDefs,
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };

    this.onRowDblClick = (row: JS5Object) => {
        navigateToEditView(row.entity);
    };

    //======//
    // Data //
    //======//

    const getData = () => {
        let criteria = {
            fetchOffset: this.pagingOptions.pageSize * (this.pagingOptions.currentPage - 1),
            fetchLimit: this.pagingOptions.pageSize,
            searchString: $location.search().searchText
        };

        this.loadingIndicator.show = true;
        FileSystemService.getFileSystems(criteria)
            .then((fileSystems: JS5Object) => {
                this.gridOptions.data = fileSystems;
                this.loadingIndicator.show = false;
            });
    };


    //=========//
    // Toolbar //
    //=========//

    const navigateToEditView = (entity: JS5Object) => {
        let fileSystemId = _.get(entity, 'id') || this.gridApi.selection.getSelectedRows()[0].id;
        $location.url(`/system/fileSystems/edit/${fileSystemId}/properties`);
    };

    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: () => true,
            onClick: () => {
                navigateToEditView({id: -1});
            }
        }, {
            label: 'Edit',
            enabled: () => {
                return !_.isEmpty(this.gridApi.selection.getSelectedRows());
            },
            onClick: navigateToEditView
        }
    ];


    //============//
    // Pagination //
    //============//

    const paginationPreviousPageHandler = () => {
        --this.pagingOptions.currentPage;
        getData();
    };

    const paginationNextPageHandler = () => {
        ++this.pagingOptions.currentPage;
        getData();
    };

    const paginationPageSizeChanged = () => {
        this.pagingOptions.currentPage = 1;
        getData();
    };

    this.paginationDefs = {
        paginationPrevPageHandler: paginationPreviousPageHandler,
        paginationNextPageHandler: paginationNextPageHandler,
        paginationPageSizeChanged: paginationPageSizeChanged,
        paginationJumpToPageHandler: getData,
        pagingOptions: PaginationService,
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        if (!PermissionsService.isAdmin()) {
            $location.url('/login');
        } else {
            PaginationService.resetToDefaultValues();
            this.pagingOptions = PaginationService;
            NavbarUtilService.viewSearchFunction = getData;
            SearchFilterService.populateCriteriaFromLocationSearch();
            getData();
        }
    };
}

angular.module('prism-ui.fileSystem').component('fileSystemSearchView', {
    templateUrl: 'system/fileSystem/searchView/file-system-search-view-template.html',
    controller: FileSystemSearchViewController
});
